import { render, staticRenderFns } from "./SelectorGeneros.vue?vue&type=template&id=0ed5ea18&scoped=true&"
import script from "./SelectorGeneros.vue?vue&type=script&lang=js&"
export * from "./SelectorGeneros.vue?vue&type=script&lang=js&"
import style0 from "./SelectorGeneros.vue?vue&type=style&index=0&id=0ed5ea18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5ea18",
  null
  
)

export default component.exports